import { createFileRoute } from '@tanstack/react-router'

import EditPnsPppkPage from '@/components/pages/backoffice/_ktg-penyuluh/pns-pppk/$pnsPppkId/_edit/containers/EditPnsPppkPage'

export const Route = createFileRoute(
  '/_backoffice/ktg-penyuluh/pns-pppk/$pnsPppkId/edit/'
)({
  component: EditPnsPppkPage
})
